import type { QuestionData } from "../../models/GetQuestions";
import stackStyles from "../QuestionTypeStack.module.scss";
import { MultipleSelectionWeb } from "./MultipleSelectionWeb";

const getCorrectPositionsForMmcq = (
  correct_answer: (number | string | null)[][],
): number[] =>
  correct_answer
    .map((item) => (Array.isArray(item) ? item[0] : item))
    .filter((v) => v != null)
    .map(Number)
    .filter((n) => !isNaN(n));

type Props = {
  questionData: QuestionData;
  selectedValue: string;
  setSelectedValue: (val: string) => void;
};

export const MultipleQuestionTypeScreen = ({
  questionData,
  selectedValue,
  setSelectedValue,
}: Props) => {
  const correctPositions = getCorrectPositionsForMmcq(
    questionData.question?.correct_answer ?? [],
  );
  const selectedIndices = selectedValue.split(",").filter(Boolean);

  const handleToggle = (pos: string) => {
    const next = selectedIndices.includes(pos)
      ? selectedIndices.filter((s) => s !== pos)
      : [...selectedIndices, pos];
    setSelectedValue(next.sort().join(","));
  };

  return (
    <div className={stackStyles.stack}>
      {questionData.question?.answer_options?.map((option, index) => {
        const val = String(index + 1);
        return (
          <MultipleSelectionWeb
            key={val}
            content={option as unknown as string}
            isSelected={selectedIndices.includes(val)}
            onToggle={() => handleToggle(val)}
            questionData={questionData}
            optionIndex={index}
            correctPositions={correctPositions}
          />
        );
      })}
    </div>
  );
};
